<template>
  <div class="text-center">
    <v-dialog
      v-model="dialog"
      width="500"
      persistent
    >
      <v-card>
        <v-card-title class="text-h5 grey lighten-2">
          {{titulo}}
        </v-card-title>

        <v-card-text>
          {{pregunta}}
        </v-card-text>

        <v-divider />

        <v-card-actions>
          <v-spacer />
          <v-btn
            color="primary"
            text
            @click="acceptar"
          >
            acceptar
          </v-btn>
          <v-btn
            color="primary"
            text
            @click="dialog = false"
          >
            cancelar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        dialog: false,
        loading: false,
        titulo: '',
        pregunta: '',
        data: '',
      }
    },
    methods: {
      open (titulo = 'titulo', pregunta = 'Pregunta', data = 'data') {
        this.dialog = true
        this.titulo = titulo
        this.pregunta = pregunta
        this.data = data
      },
      acceptar () {
        this.$emit('onDialog', this.data)
      },
      close () {
        this.dialog = false
        this.loading = false
      },
    },
  }
</script>
